import React from "react";
import { Divider, Row, Col } from 'antd';
import CustomBadge from 'components/CustomBadge';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';
import { Link } from 'react-router-dom';
import { CaretRightFilled } from '@ant-design/icons';

export default class RecentAccessedJob extends React.Component {
  constructor(props) {
    super();
    this.state = {
      data: [],
      loaded: false,
      isMobile: false,
      isIPad: false
    }
  };

  //查询该页面的数据
  async componentDidMount() {
    this.getRecentAccessedJob();
    const isMobile = window.innerWidth < 768;;
    const isIPad = window.innerWidth >= 768 && window.innerWidth < 1024;

    this.setState({ isMobile, isIPad });

  }

  getRecentAccessedJob() {
    let that = this;
    httpClient
      .get('Business/Job/GetRecentAccessedJobList')
      .then(({ data }) => {
        if (data.result) {
          this.setState({ data: data.data, loaded: true });
        } else {
          globalFunction.handleResultError(data, this.props.pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, that.props.pageComponent);
      });
  }

  render() {
    const popupWidth = this.state.isMobile ? '50%' : 'auto';
     const { rect, setShowRecentAccessedJob, jobRef } = this.props;
    return (
      this.props.rect && this.state.loaded ?
        <div
          ref={jobRef}
          style={{
            width: popupWidth,
            maxWidth: this.state.isMobile ? '50%' : '100%',
            top: this.state.isMobile ? '50px' : this.state.isIPad ? '60px' : this.props.rect.top - 5,
            left: this.state.isMobile ? '185px' : this.props.rect.left - 5,
            zIndex: 9999,
            cursor: 'pointer',
            position: 'fixed',
            borderRadius: '0.25rem',
            padding: '6px',
            backgroundColor: '#fff',
            color: '#495057',
            border: '1px solid #D5D5D5',
            boxShadow: '0 0.46875rem 2.1875rem rgb(4 9 20 / 3%), 0 0.9375rem 1.40625rem rgb(4 9 20 / 3%), 0 0.25rem 0.53125rem rgb(4 9 20 / 5%), 0 0.125rem 0.1875rem rgb(4 9 20 / 3%)'
          }}
          onMouseEnter={this.props.onPopupMouseEnter}
          onMouseLeave={this.props.onPopupMouseLeave}
        >
          <div
            style={{
              padding: '6px 10px'
            }}
          ><b>Recent Jobs</b></div>
          {
            this.state.data.map((item, i) =>
              <div
                key={i}
                style={{
                  borderTop: '1px solid #e3e3e3'
                }}
              >
                <div
                  className="RecentAccessedJobDiv"
                  style={{
                    margin: '6px 10px',
                  }}
                >
                  <CaretRightFilled
                    style={{
                      marginRight: '6px',
                    }} />
                  <Link
                    to={{ pathname: '/job/detail/' + item.JobId, companyId: item.CompanyId, areaName: 'Buisness', pageName: 'JobDetail', key: item.key }}
                    onClick={() => {
                      this.props.setShowRecentAccessedJob(false);
                    }}
                  >
                    <span className="RecentAccessedJobSpan" style={{ paddingRight: '8px', color: config.fontColor }}>{item.JobNum}</span><span className="RecentAccessedJobSpan">{item.PptAddress}</span>
                  </Link>
                </div>
              </div>)
          }
        </div> : <></>
    );
  }
}
